export const ALL_PRODUCT_UPDATED = "GENERAL_PRODUCT_UPDATE";
export const NEW_ITEM_ADDED_TO_BAG = "NEW_ITEM_ADDED_TO_BAG";
export const REMOVE_ITEM_FROM_BAG = "REMOVE_ITEM_FROM_BAG";
export const FINISH_BUTTON_CLICKED = "FINISH_BUTTON_CLICKED";
export const CLEAR_BAG = "CLEAR_BAG";
